var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.095 15.0002C29.095 1.28636 10.81 1.28642 10.81 15.0002V17.2858H8.3298C7.44039 17.2858 7.07464 18.4271 7.79839 18.9441L10.81 21.0951C10.3021 22.8729 8.21962 26.733 3.95312 27.952C4.46104 28.7139 5.934 30.2376 7.7625 30.2376L9.28624 32.5232L13.0956 31.7614C14.3654 32.7773 17.5145 34.8089 19.9525 34.8089C22.3905 34.8089 25.5396 32.7773 26.8093 31.7614L30.6187 32.5232L32.1425 30.2376C33.971 30.2376 35.444 28.7139 35.9518 27.952C31.6853 26.733 29.6028 22.8729 29.095 21.0951L32.1065 18.9441C32.8303 18.4271 32.4646 17.2858 31.5752 17.2858H29.095V15.0002Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnap);
export default __webpack_public_path__ + "static/media/snap.ab720ad88483a4d3a4d543465c2370ca.svg";
export { ForwardRef as ReactComponent };